import React from 'react';
import { CheckCircle2, ClipboardList } from 'lucide-react';

export default function SurveyThankYou({ survey, onExit, t }) {
  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="rounded-lg bg-emerald-900/30 border border-emerald-700 p-8 text-center">
        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-3" />
        <h2 className="text-2xl font-bold text-slate-100">{t('surveyThankYou')}</h2>
        <p className="text-slate-300 mt-2 whitespace-pre-wrap">
          {survey?.thank_you_md?.trim()
            ? survey.thank_you_md
            : t('surveyRecorded')}
        </p>
        {survey?.is_anonymous ? (
          <p className="text-xs text-emerald-300/80 mt-3">{t('surveySubmittedAnonymously')}</p>
        ) : null}
      </div>
      <div className="mt-6 flex justify-center">
        <button onClick={onExit}
          className="px-4 py-2 rounded bg-amber-600 hover:bg-amber-500 text-white flex items-center gap-2">
          <ClipboardList className="w-4 h-4" /> {t('surveyBackToList')}
        </button>
      </div>
    </div>
  );
}
